<script>
  import { getUrlProduct } from "$lib/utils/getUrlProduct";
  import { isOnlyProfessional } from "$lib/utils/onlyProfesionals";
  import { parsePrice } from "$lib/utils/parsePrice";
  import ButtonAddToCart from "./ButtonAddToCart.svelte";
  import ImageProduct from "./ImageProduct.svelte";
  /**@type {import ('$lib/types/index').PublicProduct}*/
  export let product;
  let isInMyWishList = false;
  const setOnMywishList = () => (isInMyWishList = !isInMyWishList);

</script>

{#if product}
  <li class="container product-card">
    <a href={getUrlProduct(product)} class="images-container">
      {#if product.images.image}
        <div class="image" class:noHover={product.images.swatch == undefined}>
          <ImageProduct productImage={product.images.image} />
        </div>
      {/if}
      {#if product.images.swatch}
        <div class="image swatch">
          <ImageProduct productImage={product.images.swatch} />
        </div>
      {/if}
    </a>
    <div class="info-container">
      <a href={getUrlProduct(product)} class="info-products">
        <p>{product.short_name || product.name}</p>
        <div class="sku">
          <span>{product.typeProduct || "Red Carpet Manicure"}</span>
          <span>{product.sku}</span>
        </div>
      </a>
      <div class="action-buttons">
        {#if isOnlyProfessional(product.sku)}
          <p class="only-professionals">Only for Professional Customers</p>
        {:else}
          <ButtonAddToCart {product} />
        {/if}
        {#if product.specialPrice}
         <div class="special-prices">
          <p class="special">{parsePrice("GBP", "en-gb", product.specialPrice)}</p>
          <p class="price">{parsePrice("GBP", "en-gb", product.price)}</p>
        </div>
        {:else}
          <p class="price">{parsePrice("GBP", "en-gb", product.price)}</p>
        {/if}
      </div>
    </div>
  </li>
{/if}

<style>
  a {
    text-decoration: none;
  }
  li {
    list-style: none;
  }
  .container {
    border-radius: 3.5rem;
    border: 0.3rem solid var(--global);
    aspect-ratio: 0.78/1;
    max-width: 350px;
    width: 100%;
    min-width: 100%;
    padding: 0.5rem 1rem;
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    gap: 1rem;
    overflow: hidden;
  }
  .images-container {
    width: 70%;
    aspect-ratio: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: start;
    overflow: hidden;
  }
  .images-container .image {
    height: 100%;
    min-width: 100%;
    transition: all 300ms ease;
  }
  .images-container:hover .image {
    transform: translateX(-100%);
  }
  .images-container:hover .image.noHover {
    transform: translateX(0);
  }
  .info-container {
    width: 85%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1.5rem;
  }
  .info-products {
    display: flex;
    flex-direction: column;
    padding: 0 5px;
  }
  .info-products p {
    font-size: clamp(1.6rem, 3svw, 1.8rem);
    font-family: "sirenia";
    text-transform: uppercase;
    color: var(--pink);
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 1;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
  }
  .sku {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .sku span {
    font-size: clamp(1.4rem, 3svw, 1.5rem);
    line-height: 1;
    color: var(--pink);
    text-transform: uppercase;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    line-height: 1;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    overflow: hidden;
    margin: 5px 0 1rem 0;
  }
  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .special-prices{
    display: flex;
    align-items: flex-start;
    gap: 1rem;
  }
  .price {
    font-size: clamp(1.5rem, 2vw, 2.4rem);
    font-weight: 600;
    color: var(--pink);
  }
  .special-prices .price{
    font-size: 1.2rem;
    position: relative;
  }
  .special-prices .price::before{
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 2px;
    width: 120%;
    background-color: var(--pink);
  }
  .special {
    font-size: clamp(1.5rem, 2vw, 2.4rem);
    color: var(--red);
    font-weight: 600;
  }
  @keyframes heart {
    0% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(1.4);
    }
    100% {
      transform: scale(1);
    }
  }

  @media (max-width: 767px) {
    .container {
      border-radius: 3rem;
    }
    .images-container {
      width: 95%;
    }
    .info-container {
      width: 95%;
    }
  }
</style>
